import { ICorrespondenceViewModel, ISolicitationViewModel } from 'viewModels';
import { IAddCorrespondenceInputModel, IDeleteCorrespondenceInputModel } from 'inputModels';
import api from '../services/api/axios';

const getAll = () =>
  new Promise<ICorrespondenceViewModel[]>((resolve) => {
    api
      .get(`/correspondence`)
      .then(({ data }) => resolve(data))
      .catch(() => resolve([] as ICorrespondenceViewModel[]));
  });

const getCorrespondencesByUser = () =>
  new Promise<ICorrespondenceViewModel[]>((resolve, reject) => {
    api
      .get(`/correspondence/get-correspondences-by-user`)
      .then(({ data }) => resolve(data))
      .catch(reject);
  });
const getCorrespondenceById = (id: string) =>
  new Promise<ICorrespondenceViewModel>((resolve, reject) => {
    api
      .get(`/correspondence/get-correspondence-by/${id}`)
      .then(({ data }) => resolve(data))
      .catch(reject);
  });
const addCorrespondence = async (input: IAddCorrespondenceInputModel) =>
  new Promise<string>((resolve, reject) => {
    api
      .post(`/correspondence/add-correspondence/`, input)
      .then(({ data }) => resolve(data))
      .catch(reject);
  });
const deleteCorrespondence = async (deleteCorrespondenceData: IDeleteCorrespondenceInputModel) =>
  new Promise<string>((resolve, reject) => {
    api
      .post(`/correspondence/delete-correspondence`, deleteCorrespondenceData)
      .then(({ data }) => resolve(data))
      .catch(reject);
  });
const correspondencesHasSolicitation = async (id: string) =>
  new Promise<ISolicitationViewModel[]>((resolve, reject) => {
    api
      .get(`/correspondence/correspondence-has-solicitation/${id}`)
      .then(({ data }) => resolve(data))
      .catch(reject);
  });
const CorrespondenceController = {
  getAll,
  getCorrespondencesByUser,
  getCorrespondenceById,
  addCorrespondence,
  deleteCorrespondence,
  correspondencesHasSolicitation,
};

export default CorrespondenceController;
